import React from "react";
import { FaKey } from "react-icons/fa";
import "../index.css";
import CodeBlock from "./CodeBlock";

const API = "https://saas.todoai.ai/api";

const buildNode = (mode) => `import crypto from "crypto";

const API_KEY = process.env.TODOAI_API_KEY;       // pk_YOUR_API_KEY
const SECRET_KEY = process.env.TODOAI_SECRET_KEY; // YOUR_SECRET_KEY, server only
const domain = "YOUR_DOMAIN";

// X-Signature = HMAC-SHA256 of the domain value, as a hex string
const signature = crypto
  .createHmac("sha256", SECRET_KEY)
  .update(domain)
  .digest("hex");

const res = await fetch("${API}/avatar/embed/session", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY,
    "X-Signature": signature,
  },
  body: JSON.stringify({
    avatar_id: "YOUR_AVATAR_ID",
    domain,${mode ? `\n    mode: "${mode}",` : ""}
  }),
});

console.log(await res.json()); // { url, expires_in }`;

const buildPython = (mode) => `import hashlib
import hmac
import os

import requests

API_KEY = os.environ["TODOAI_API_KEY"]          # pk_YOUR_API_KEY
SECRET_KEY = os.environ["TODOAI_SECRET_KEY"]    # YOUR_SECRET_KEY, server only
domain = "YOUR_DOMAIN"

# X-Signature = HMAC-SHA256 of the domain value, as a hex string
signature = hmac.new(SECRET_KEY.encode(), domain.encode(), hashlib.sha256).hexdigest()

res = requests.post(
    "${API}/avatar/embed/session",
    headers={"X-API-Key": API_KEY, "X-Signature": signature},
    json={
        "avatar_id": "YOUR_AVATAR_ID",
        "domain": domain,${mode ? `\n        "mode": "${mode}",` : ""}
    },
)
print(res.json())  # {"url": "...", "expires_in": 600}`;

const buildCurl = (mode) => `DOMAIN="YOUR_DOMAIN"
SIGNATURE=$(printf %s "$DOMAIN" | openssl dgst -sha256 -hmac "YOUR_SECRET_KEY" | awk '{print $NF}')

curl -X POST ${API}/avatar/embed/session \\
  -H "Content-Type: application/json" \\
  -H "X-API-Key: pk_YOUR_API_KEY" \\
  -H "X-Signature: $SIGNATURE" \\
  -d '{ "avatar_id": "YOUR_AVATAR_ID", "domain": "'"$DOMAIN"'"${mode ? `, "mode": "${mode}"` : ""} }'`;

const SignatureExample = ({ mode }) => (
  <div className="docs-section">
    <h2 className="docs-section-title">
      <FaKey /> Generate Signature Example
    </h2>
    <p>
      Every request from your backend sends <code>X-API-Key</code> and{" "}
      <code>X-Signature</code>. The signature is the HMAC-SHA256 (hex) of the{" "}
      <code>domain</code> value, using your secret key. For endpoints without a
      domain, such as <code>/api/avatar/list</code>, sign an empty string.
      Create it on your server only. The examples read your credentials from the{" "}
      <code>TODOAI_API_KEY</code> and <code>TODOAI_SECRET_KEY</code> environment
      variables.
    </p>
    <CodeBlock title="Node.js" code={buildNode(mode)} scroll />
    <CodeBlock title="Python" code={buildPython(mode)} scroll />
    <CodeBlock title="cURL (OpenSSL)" code={buildCurl(mode)} scroll />
  </div>
);

export default SignatureExample;
